import { Component, HostBinding, ElementRef, OnInit, Input } from '@angular/core';
import { ColorifyPalette, Colorify } from '../core/behaviors/colorify';

export type ButtonSizes = 'small' | 'medium' | 'large' | undefined;

export interface Button {
  color: ColorifyPalette;
  fullWidth: boolean;
  inverted: boolean;
  outlined: boolean;
  size: ButtonSizes;
}

@Component({
  selector: 'button[wi-button], button[wi-rounded-button]',
  template: '<span class="button__wrapper"><ng-content></ng-content></span>'
})
export class ButtonComponent extends Colorify implements Button, OnInit {
  @Input() color: ColorifyPalette;
  @Input() fullWidth: boolean;
  @Input() inverted: boolean;
  @Input() outlined: boolean;
  @Input() size: ButtonSizes;

  private _buttonClasses = [];

  constructor(el: ElementRef, private _el: ElementRef) {
    super(el);
  }

  ngOnInit() {
    this._getButtonClasses();
  }

  private _getEl() {
    return this._el.nativeElement;
  }

  private _getButtonClasses() {
    this._getAttributes();
    this._getModifiers();
    this._getEl().classList.add(...this._buttonClasses);
  }

  private _getAttributes() {
    this._buttonAttribute('wi-button', ['button']);
    this._buttonAttribute('wi-rounded-button', ['button', 'is-rounded']);
  }

  private _getModifiers() {
    this._getButtonSize();
    this._buttonModifier(this.fullWidth, 'is-fullwidth');
    this._buttonModifier(this.inverted, 'is-inverted');
    this._buttonModifier(this.outlined, 'is-outlined');
  }

  private _buttonAttribute(attribute: string, classes: string[]) {
    if (this._getEl().hasAttribute(attribute)) {
      classes.forEach(className => {
        this._buttonClasses.push(`${className}`);
      });
    }
  }

  private _getButtonSize() {
    if (this.size) {
      this._buttonClasses.push(`is-${this.size}`);
    }
  }

  private _buttonModifier(modifier: any, className: string) {
    if (modifier) {
      this._buttonClasses.push(`${className}`);
    }
  }
}
